import lazyLoading from './lazyLoading.js'

export default {
  name: 'users',
  meta: {
    title: 'Users',
    iconClass: 'vuestic-icon vuestic-icon-user'
  },
  path: '/users',
  component: lazyLoading('users/Users')
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/users.js